import { render, staticRenderFns } from "./TipsCmp.vue?vue&type=template&id=5d6fc65e&scoped=true"
import script from "./TipsCmp.vue?vue&type=script&lang=js"
export * from "./TipsCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6fc65e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6fc65e')) {
      api.createRecord('5d6fc65e', component.options)
    } else {
      api.reload('5d6fc65e', component.options)
    }
    module.hot.accept("./TipsCmp.vue?vue&type=template&id=5d6fc65e&scoped=true", function () {
      api.rerender('5d6fc65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/cmp/TipsCmp.vue"
export default component.exports